import { render, staticRenderFns } from "./purchase-order-add.vue?vue&type=template&id=5e8f1f29&scoped=true&"
import script from "./js/purchase-order-add.js?vue&type=script&lang=js&"
export * from "./js/purchase-order-add.js?vue&type=script&lang=js&"
import style0 from "./purchase-order-add.vue?vue&type=style&index=0&id=5e8f1f29&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8f1f29",
  null
  
)

export default component.exports